module.exports = __webpack_public_path__ + "static/media/THREE.ef493ab6.png";